import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import Icon from 'components/DesignSystem/Icon';
import { IconType } from 'components/DesignSystem/Icon/icons';

import './index.scss';

interface TabItem {
  to: string;
  icon: IconType;
  label: string;
  matchPrefixes?: string[];
}

const TABS: TabItem[] = [
  { to: '/home', icon: 'home', label: 'Home' },
  { to: '/fileviewer', icon: 'archives', label: 'Arquivos' },
  {
    to: '/meteorology', icon: 'meteorology', label: 'Meteo', matchPrefixes: ['/meteorology', '/agro'],
  },
  { to: '/flux', icon: 'flux', label: 'Flux' },
];

export default function BottomTabBar({ onMoreClick }: { onMoreClick: () => void }) {
  const { pathname } = useLocation();

  return (
    <nav className="mobile-tab-bar" aria-label="Navegação principal">
      {TABS.map((tab) => {
        const isActive = (tab.matchPrefixes ?? [tab.to]).some(
          (prefix) => pathname.startsWith(prefix),
        );

        return (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={`mobile-tab-item${isActive ? ' active' : ''}`}
            aria-label={tab.label}
          >
            <Icon iconType={tab.icon} color="currentColor" />
            <span className="mobile-tab-label">{tab.label}</span>
            {isActive && <span className="mobile-tab-indicator" />}
          </NavLink>
        );
      })}
      <button type="button" className="mobile-tab-item" aria-label="Mais" onClick={onMoreClick}>
        <Icon iconType="more_horiz" color="currentColor" />
        <span className="mobile-tab-label">Mais</span>
      </button>
    </nav>
  );
}
